import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { ILocation } from "../../models/ILocation";
import { makeCustomEvent } from "../../Utils";
import { litIf } from "../LitUtils";
import { choose } from "lit/directives/choose.js";

import "../ProgressSpinner/ProgressSpinner";
import "../GoToLocationControl";

type AddPlaceView = "main" | "acquiring" | "coords";

@customElement("ds-add-place")
export class AddPlace extends BaseElement {
    @property({ type: Object }) selectedLocation: ILocation | undefined;
    @property({ type: Object }) mapCenter: ILocation | undefined;

    @state() _view: AddPlaceView = "main";
    @state() _coordLocation: ILocation | undefined;

    static override styles = [
        Style,
        css`
            .container {
                width: 100%;
            }
        `,
    ];

    private _accept(location: ILocation | undefined) {
        if (location) {
            this.dispatchEvent(
                makeCustomEvent("ds-accept", {
                    location,
                })
            );
        }
    }

    private _getCurrentLocation() {
        navigator.geolocation.getCurrentPosition(
            async (pos: GeolocationPosition) => {
                this._accept({
                    lat: pos.coords.latitude,
                    lon: pos.coords.longitude,
                });
            },
            () => {},
            {
                enableHighAccuracy: true,
            }
        );
        this._view = "acquiring";
    }

    override render() {
        return html` <div class="container flex-column">
            ${choose(this._view, [
                [
                    "main",
                    () => html`
                        ${litIf(
                            !!this.selectedLocation,
                            () =>
                                html`<sl-button @click=${() => this._accept(this.selectedLocation)}
                                    >Selected location</sl-button
                                >`
                        )}
                        <sl-button @click=${() => this._getCurrentLocation()}
                            >My location</sl-button
                        >
                        ${litIf(
                            !!this.mapCenter,
                            () =>
                                html`<sl-button @click=${() => this._accept(this.mapCenter)}
                                    >Map center</sl-button
                                >`
                        )}
                        <sl-button @click=${() => (this._view = "coords")}>Coordinates</sl-button>
                    `,
                ],
                [
                    "acquiring",
                    () =>
                        html`<ds-progress-spinner
                            message="Acquiring location"
                        ></ds-progress-spinner>`,
                ],
                [
                    "coords",
                    () =>
                        html` <ds-go-to-location-control
                                @ds-changed=${(e: CustomEvent) => {
                                    this._coordLocation = e.detail.location;
                                    e.stopPropagation();
                                }}
                                @ds-error=${() => (this._coordLocation = undefined)}
                            ></ds-go-to-location-control>
                            <div class="button-row">
                                <sl-button
                                    variant="success"
                                    ?disabled=${!this._coordLocation}
                                    @click=${() => {
                                        this._accept(this._coordLocation);
                                    }}
                                >
                                    Create place</sl-button
                                >
                            </div>`,
                ],
            ])}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-add-place": AddPlace;
    }
}
